<template>
  <section class="not-found-wrapper">
			<div class="container">
				<div class="not-found-sec">
					<div class="row align-items-center">
						<div class="col-lg-6 col-md-6 col-sm-12">
							<div class="found-img">
								<img src="@/assets/images/not-found.jpg" alt="error">
							</div>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-12">
							<div class="found-heading">
								<h1>404</h1>
								<p>Not Found</p>
								<router-link :to="{name: 'Home'}" class="btn_submit_cl">Go To Homepage</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
</template>

<script>
export default {
    name: '404'
}
</script>

<style>

</style>